__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "hub";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "5.6.0", () => (__webpack_require__.e(817).then(() => (() => (__webpack_require__(7817))))));
			register("@emotion/react", "11.11.1", () => (Promise.all([__webpack_require__.e(361), __webpack_require__.e(522), __webpack_require__.e(702)]).then(() => (() => (__webpack_require__(6702))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(522), __webpack_require__.e(631), __webpack_require__.e(225)]).then(() => (() => (__webpack_require__(225))))));
			register("@unform/core", "2.1.6", () => (Promise.all([__webpack_require__.e(522), __webpack_require__.e(610)]).then(() => (() => (__webpack_require__(1610))))));
			register("axios", "0.24.0", () => (__webpack_require__.e(569).then(() => (() => (__webpack_require__(4569))))));
			register("i18next", "21.10.0", () => (__webpack_require__.e(105).then(() => (() => (__webpack_require__(1105))))));
			register("invariant", "2.2.4", () => (__webpack_require__.e(176).then(() => (() => (__webpack_require__(2176))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(456).then(() => (() => (__webpack_require__(456))))));
			register("module-federation-import-remote", "1.0.24", () => (__webpack_require__.e(114).then(() => (() => (__webpack_require__(5114))))));
			register("react-bootstrap", "2.9.1", () => (Promise.all([__webpack_require__.e(102), __webpack_require__.e(522), __webpack_require__.e(770), __webpack_require__.e(162), __webpack_require__.e(90)]).then(() => (() => (__webpack_require__(1102))))));
			register("react-dom", "17.0.1", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(522)]).then(() => (() => (__webpack_require__(4164))))));
			register("react-i18next", "12.1.4", () => (Promise.all([__webpack_require__.e(522), __webpack_require__.e(230)]).then(() => (() => (__webpack_require__(9230))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(542), __webpack_require__.e(522), __webpack_require__.e(101)]).then(() => (() => (__webpack_require__(1542))))));
			register("react-select", "5.8.0", () => (Promise.all([__webpack_require__.e(361), __webpack_require__.e(502), __webpack_require__.e(522), __webpack_require__.e(770), __webpack_require__.e(631), __webpack_require__.e(690)]).then(() => (() => (__webpack_require__(1502))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(655), __webpack_require__.e(522)]).then(() => (() => (__webpack_require__(9655))))));
			register("react", "17.0.1", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(2791))))));
			register("sweetalert2-react-content", "4.2.0", () => (Promise.all([__webpack_require__.e(522), __webpack_require__.e(770), __webpack_require__.e(86)]).then(() => (() => (__webpack_require__(8086))))));
			register("sweetalert2", "11.10.1", () => (__webpack_require__.e(830).then(() => (() => (__webpack_require__(1830))))));
			register("yup", "0.32.11", () => (Promise.all([__webpack_require__.e(21), __webpack_require__.e(181)]).then(() => (() => (__webpack_require__(4021))))));
			register("zustand", "4.4.7", () => (Promise.all([__webpack_require__.e(522), __webpack_require__.e(847)]).then(() => (() => (__webpack_require__(5847))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};